import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpClub'

// The Mundo Gamer team's view of the clubs (club-api, admin/clubs). Every change needs a written reason.
export const clubs = (params = '') => Http.get(`/admin/clubs${serialize(params)}`)

export const club = id => Http.get(`/admin/clubs/${id}`)

export const clubPosts = (id, params = '') => Http.get(`/admin/clubs/${id}/posts${serialize(params)}`)

export const removeClubPost = ({ id, uuid, reason }) => Http.delete(`/admin/clubs/${id}/posts/${uuid}`, { data: { reason } })

export const suspendClub = ({ id, reason }) => Http.post(`/admin/clubs/${id}/suspend`, { reason })

export const reactivateClub = ({ id, reason }) => Http.post(`/admin/clubs/${id}/reactivate`, { reason })

export const setClubSensitive = ({ id, value, reason }) => Http.put(`/admin/clubs/${id}/sensitive`, { value, reason })

// Memberships of a club (paying ones) and the refund of their latest paid cycle. The refund only asks the payment
// provider; access and the ledger follow when it confirms.
export const clubSubscriptions = (id, params = '') => Http.get(`/admin/clubs/${id}/subscriptions${serialize(params)}`)

export const refundClubSubscription = ({
	id, subscriptionId, reason, amountCents, idempotencyKey,
}) => Http.post(`/admin/clubs/${id}/subscriptions/${subscriptionId}/refund`, {
	reason,
	amount_cents: amountCents || undefined,
	idempotency_key: idempotencyKey,
})
